import {getEmployeeAudits} from "../api/audit";
import {Audit} from "../interfaces/AuditInterface";

const fetchEmployeeAudit = async (employeeID: string, payPeriodID: number): Promise<Audit[]> => {
    try {
        const audits = await getEmployeeAudits(employeeID, payPeriodID);
        return audits;
    } catch (err) {
        console.error("Error fetching employee audit in data layer:", err);
        throw err;
    }
};

export {fetchEmployeeAudit};